// Components==============
import { useOnClickOutside } from 'hooks/useOnClickOutside';
import React, { useContext, useEffect, useRef } from 'react';
import { InputColor, TranslateType } from 'typings';
import { FormContext } from 'utilities/FormContext';
import './Form.module.scss';
// =========================

type Props = {
  name: string;
  label?: TranslateType;
  required?: boolean;
  autoComplete?: string;
  color?: InputColor;
  placeholder?: TranslateType;
  ext_formValue?: string;
  ext_onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  resizeTrigger?: boolean;
  handleSave?: () => void;
  isEditing?: boolean;
  setIsEditing?: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function Textarea({
  name,
  label,
  required = true,
  autoComplete,
  color = 'grey',
  placeholder = '',
  ext_formValue,
  ext_onChange,
  resizeTrigger,
  handleSave,
  isEditing,
  setIsEditing,
}: Props) {
  const { onChange, formValues, errors } = useContext(FormContext);

  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const spanRef = useRef<HTMLSpanElement>(null);

  console.log(color);

  useEffect(() => {
    if (!textareaRef.current || !spanRef.current) return;
    if (
      (formValues?.[name] && formValues?.[name].length > 50) ||
      (ext_formValue && ext_formValue?.length > 50)
    ) {
      const { scrollHeight } = textareaRef.current;

      if (spanRef.current.style.height === `${scrollHeight}px`) return;
      spanRef.current.style.height = '0px';
      spanRef.current.style.height = `${scrollHeight}px`;
    }
  }, [formValues?.[name] || ext_formValue, resizeTrigger]);

  function onKeyDown(e?: React.KeyboardEvent<HTMLTextAreaElement>) {
    if (!handleSave) return;

    if (e?.key === 'Enter' && !!ext_formValue && setIsEditing) {
      textareaRef.current?.blur();
      setIsEditing(false);
      handleSave();
    }
  }

  useOnClickOutside({
    refs: [spanRef],
    handler: handleSave || (() => undefined),
    condition: isEditing,
  });

  return (
    <div styleName="wrapper">
      {label && <label htmlFor={name}>{label}</label>}
      <span ref={spanRef}>
        <textarea
          name={name}
          onChange={onChange || ext_onChange}
          value={formValues?.[name] || ext_formValue}
          required={required}
          autoComplete={autoComplete}
          styleName={`textarea ${color}`}
          ref={textareaRef}
          placeholder={placeholder as string}
          onKeyDown={onKeyDown}
        />
      </span>
      {errors && errors[name][0] ? (
        <p styleName="error">{errors[name][0]}</p>
      ) : null}
    </div>
  );
}
